import { enumServe } from "@/service";
import { defineStore } from "pinia";

export const useEnumStore = defineStore("enum", {
  state: () => ({
    enumList: false,
  }),
  actions: {
    async getEnumList() {
      const res = await enumServe.allEnum();
      if (res.success) {
        let data = {};
        for (const key in res.data) {
          const value = res.data[key];
          value.forEach((item) => {
            if (!data[key]) {
              data[key] = {};
            }
            data[key][item.enum_key] = item.enum_value;
          });
        }
        this.enumList = data;
      }
    },
  },
});
